import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { commonReducerFor, initialState as commonInitialState } from "../../../Redux/CommonReducer";
import { LocalReducer, initialState as localInitialState } from "./LocalStore";
import { filtersReducerFor, initialState as filterInitialState } from "./FilterStore";
import { BookingFormReducer, initialState as bookingFormInitialState } from "./BookingFormStore";
import { visitsReducerFor, initialState as visitsInitialState } from "./VisitsStore";
import { visitorsReducerFor, initialState as visitorsInitialState } from "./VisitorLogsStore";
import { loadState, getPersistableState } from "./VisitorsPersistence";
import { merge, throttle } from "lodash";
import {ACTIVITY_TYPE, MANAGEMENT_PAGE, ACTIVITY_PAGE, MANAGEMENT_TYPE} from "../Visitors";
import {initialState as passPrintInitialState, PassPrintReducer} from "./PassPrintStore";

export const visitorsModuleSliceReducer = combineReducers({
    common: commonReducerFor('VISITORS'),
    local: LocalReducer,
    bookingForm: BookingFormReducer,
    [MANAGEMENT_PAGE]: combineReducers({
        filters: filtersReducerFor(MANAGEMENT_PAGE),
        [MANAGEMENT_TYPE.UPCOMING]: visitsReducerFor(MANAGEMENT_TYPE.UPCOMING),
        [MANAGEMENT_TYPE.PAST]: visitsReducerFor(MANAGEMENT_TYPE.PAST),
    }),
    [ACTIVITY_PAGE]: combineReducers({
        filters: filtersReducerFor(ACTIVITY_PAGE),
        [ACTIVITY_TYPE.SIGNED_IN]: visitorsReducerFor(ACTIVITY_PAGE, ACTIVITY_TYPE.SIGNED_IN),
        [ACTIVITY_TYPE.SIGNED_OUT]: visitorsReducerFor(ACTIVITY_PAGE, ACTIVITY_TYPE.SIGNED_OUT),
        [ACTIVITY_TYPE.ALL]: visitorsReducerFor(ACTIVITY_PAGE, ACTIVITY_TYPE.ALL),
    }),
    passPrint: PassPrintReducer
});

export const initialState = {
    common: commonInitialState,
    bookingForm: bookingFormInitialState,
    [MANAGEMENT_PAGE]: {
        filters: filterInitialState,
        [MANAGEMENT_TYPE.UPCOMING]: visitsInitialState,
        [MANAGEMENT_TYPE.PAST]: visitsInitialState,
    },
    [ACTIVITY_PAGE]: {
        filters: filterInitialState,
        [ACTIVITY_TYPE.SIGNED_IN]: visitorsInitialState,
        [ACTIVITY_TYPE.SIGNED_OUT]: visitorsInitialState,
        [ACTIVITY_TYPE.ALL]: visitorsInitialState,
    },
    passPrint: passPrintInitialState
}

//const persistedState = loadState();
//const preloadedState = {};
//merge(preloadedState, initialState, persistedState);
//
//// TODO: Disable devtools on production. How?
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//
//const rootStore = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(thunk)));
//
//rootStore.subscribe(
//    throttle( () => {
//        saveState(rootStore.getState());
//    }, 1000)
//);
//
//export { rootStore };
